// Rebuilt canvas nodes must be able to paint an already decoded portrait on
// their first frame. HTTP caching alone still leaves an asynchronous Image load.
export class TokenAvatarCache {
  constructor(limit = 128) {
    this.limit = limit;
    this.entries = new Map();
  }

  load(url, redraw) {
    let entry = this.entries.get(url);
    if (!entry) {
      const image = new Image();
      entry = { image, listeners: new Set() };
      image.crossOrigin = 'anonymous';
      image.onload = () => {
        for (const listener of entry.listeners) listener();
        entry.listeners.clear();
      };
      image.onerror = () => {
        entry.listeners.clear();
        if (this.entries.get(url) === entry) this.entries.delete(url);
      };
      image.src = url;
    }
    this.entries.delete(url);
    this.entries.set(url, entry);
    while (this.entries.size > this.limit) this.entries.delete(this.entries.keys().next().value);
    if (!entry.image.complete) entry.listeners.add(redraw);
    return entry.image;
  }
}

export const tokenAvatars = new TokenAvatarCache();
